'use client'
import React, { FC, useState } from 'react'
import { useCollapse } from 'react-collapsed'

import styles from './Collapse.module.scss'
import { CollapseProps } from './Collapse.types'
import cn from 'classnames'
export const Collapse: FC<CollapseProps> = ({
  title,
  titleCollapsed,
  isOpen = false,
  hideArrow = false,
  titleClassName,
  className,
  children,
}) => {
  const [isExpanded, setExpanded] = useState(isOpen)
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded })

  const printCollapseHeader = () => {
    if (isExpanded) {
      return title
    }

    return titleCollapsed ? titleCollapsed : title
  }

  return (
    <section>
      <button
        {...getToggleProps({
          onClick: () => setExpanded(prevExpanded => !prevExpanded),
        })}
        className={cn(styles.header, titleClassName && titleClassName, {
          [styles.isOpened]: isExpanded,
        })}
      >
        <span>{printCollapseHeader()}</span>
        {!hideArrow && (
          <span className={styles.arrow}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="10"
              viewBox="0 0 1024 976"
            >
              <path d="m0 652.327 104.472 104.279 506.245-505.307L506.245 147.02 0 652.327zm919.625 104.277L1024 652.229 511.169 139.396 406.794 243.771l512.831 512.833z" />
            </svg>
          </span>
        )}
      </button>
      <section className={cn(className && className)} {...getCollapseProps()}>
        {children}
      </section>
    </section>
  )
}
